import { render, staticRenderFns } from "./PriceAreaTheme0.vue?vue&type=template&id=6c166ff3&scoped=true"
import script from "./PriceAreaTheme0.vue?vue&type=script&lang=js"
export * from "./PriceAreaTheme0.vue?vue&type=script&lang=js"
import style0 from "./PriceAreaTheme0.vue?vue&type=style&index=0&id=6c166ff3&prod&scoped=true&lang=css"
import style1 from "./PriceAreaTheme0.vue?vue&type=style&index=1&id=6c166ff3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c166ff3",
  null
  
)

export default component.exports